import { type FieldError, type Control, type FieldPath, type FieldValues, useController } from 'react-hook-form';
import Checkbox from '../Checkbox';
import type { CheckboxProps as BaseCheckboxProps } from '../Checkbox';

export interface ControlledCheckboxProps<TFieldValues extends FieldValues = FieldValues> extends Omit<BaseCheckboxProps, 'checked' | 'onChange' | 'onBlur' | 'name' | 'ref' | 'error'> {
    name: FieldPath<TFieldValues>;
    control: Control<TFieldValues>;
    error?: FieldError;
    className?: string;
}

export default function ControlledCheckbox<TFieldValues extends FieldValues = FieldValues>({
    name,
    control,
    error: errorProp,
    className = '',
    ...props
}: ControlledCheckboxProps<TFieldValues>) {
    const { field } = useController({
        control,
        name,
    });

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        field.onChange(event.target.checked);
    };

    const handleBlur = () => {
        field.onBlur();
    };

    return (
        <Checkbox
            className={className}
            checked={field.value || false}
            onChange={handleChange}
            onBlur={handleBlur}
            {...props}
        />
    );
}
